import { Component, OnInit, inject } from '@angular/core';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { HeadService } from '../../services/head.service';
import { TitleService } from '../../services/title.service';
import { BreadCrumbComponent } from '../breadcrumb/breadcrumb.component';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    imports: [BreadCrumbComponent]
})
export class PrivacyComponent implements OnInit {
  private titleService = inject(TitleService);
  private breadcrumbService = inject(BreadcrumbService);
  private headService = inject(HeadService);


  ngOnInit(): void {
    const title = 'Privacy';
    this.titleService.set(title);
    this.breadcrumbService.set(title);
    this.headService.setMetaDescription(title);
  }
}
